import { DateTime } from 'luxon'

/**
 * @param { paymentDate } - Data w dowolnym formacie tekstowym 
 * Funkcja pomocnicza zamieniająca podaną datę z harmonogramu na format 01.01.2000
*/
export const paymentDateToDisplayString = (paymentDate: string, dateFormat: string = 'dd.MM.yyyy') => {
   return DateTime.fromISO(new Date(paymentDate).toISOString()).toFormat(dateFormat)
}